export default __webpack_public_path__ + "static/media/slide3.6954ea86.png";